var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-padding fit scroll" }, [
    _c("div", { staticClass: "q-pb-xl" }, [
      _c("div", { staticClass: "q-pb-xl" }, [
        _c("h5", [_vm._v(" Drivers License ")]),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-select", {
                  attrs: {
                    "float-label": "Drivers License State",
                    value: _vm.driversLicenseForm.LK_STATE_ID,
                    options: _vm.stateOptions,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.driversLicenseForm.LK_STATE_ID.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.driversLicenseForm
                          .LK_STATE_ID.$invalid
                      }
                    ]
                  },
                  on: {
                    blur:
                      _vm.validation.driversLicenseForm.DRIVERS_LICENSE.$touch,
                    change: function(val) {
                      return _vm.updateForm({
                        form: "driversLicenseForm",
                        field: "LK_STATE_ID",
                        value: val
                      })
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error:
                    _vm.validation.driversLicenseForm.DRIVERS_LICENSE.$error,
                  "error-label": _vm.driversLicenseError
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Drivers License Number",
                    disable: !_vm.driversLicenseForm.LK_STATE_ID,
                    value: _vm.driversLicenseForm.DRIVERS_LICENSE,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.driversLicenseForm.LK_STATE_ID.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.driversLicenseForm
                          .LK_STATE_ID.$invalid
                      }
                    ],
                    required: ""
                  },
                  on: {
                    blur:
                      _vm.validation.driversLicenseForm.DRIVERS_LICENSE.$touch,
                    keyup: function($event) {
                      $event.stopPropagation()
                      _vm.updateForm({
                        form: "driversLicenseForm",
                        field: "DRIVERS_LICENSE",
                        value: $event.target.value.toUpperCase()
                      })
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "q-pb-xl" }, [
        _c("h5", [_vm._v(" Details ")]),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_LAST_NAME.$error,
                  "error-label": "Last name is required"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Last Name",
                    value: _vm.studentForm.STUDENT_LAST_NAME,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.studentForm.STUDENT_LAST_NAME.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.studentForm.STUDENT_LAST_NAME
                          .$invalid
                      }
                    ],
                    required: ""
                  },
                  on: {
                    blur: _vm.validation.studentForm.STUDENT_LAST_NAME.$touch,
                    keyup: function($event) {
                      $event.stopPropagation()
                      _vm.updateForm({
                        form: "studentForm",
                        field: "STUDENT_LAST_NAME",
                        value: $event.target.value
                      })
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_FIRST_NAME.$error,
                  "error-label": "First name is required"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "First Name",
                    value: _vm.studentForm.STUDENT_FIRST_NAME,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.studentForm.STUDENT_FIRST_NAME.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.studentForm
                          .STUDENT_FIRST_NAME.$invalid
                      }
                    ],
                    required: ""
                  },
                  on: {
                    blur: _vm.validation.studentForm.STUDENT_FIRST_NAME.$touch,
                    keyup: function($event) {
                      $event.stopPropagation()
                      _vm.updateForm({
                        form: "studentForm",
                        field: "STUDENT_FIRST_NAME",
                        value: $event.target.value
                      })
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Middle Name",
                    value: _vm.studentForm.STUDENT_MIDDLE_NAME,
                    required: ""
                  },
                  on: {
                    keyup: function($event) {
                      $event.stopPropagation()
                      _vm.updateForm({
                        form: "studentForm",
                        field: "STUDENT_MIDDLE_NAME",
                        value: $event.target.value
                      })
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-select", {
                  attrs: {
                    "float-label": "Suffix",
                    value: _vm.studentForm.STUDENT_SUFFIX,
                    options: _vm.suffixOptions
                  },
                  on: {
                    change: function(val) {
                      return _vm.updateForm({
                        form: "studentForm",
                        field: "STUDENT_SUFFIX",
                        value: val
                      })
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-datetime", {
                  attrs: {
                    type: "date",
                    "float-label": "Date of Birth",
                    format: "MM/D/YYYY",
                    value: _vm.studentForm.STUDENT_DOB,
                    required: ""
                  },
                  on: {
                    input: function(val) {
                      return _vm.updateForm({
                        form: "studentForm",
                        field: "STUDENT_DOB",
                        value: val
                      })
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              { staticClass: "q-pa-md col-4" },
              [
                _c("q-select", {
                  attrs: {
                    "float-label": "Gender",
                    value: _vm.studentForm.STUDENT_GENDER,
                    options: _vm.genderOptions
                  },
                  on: {
                    change: function(val) {
                      return _vm.updateForm({
                        form: "studentForm",
                        field: "STUDENT_GENDER",
                        value: val
                      })
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-6",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_EMAIL.$error,
                  "error-label": "Must be a valid email"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Email",
                    value: _vm.studentForm.STUDENT_EMAIL,
                    required: ""
                  },
                  on: {
                    blur: _vm.validation.studentForm.STUDENT_EMAIL.$touch,
                    keyup: function($event) {
                      $event.stopPropagation()
                      _vm.updateForm({
                        form: "studentForm",
                        field: "STUDENT_EMAIL",
                        value: $event.target.value
                      })
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-6",
                attrs: {
                  error: _vm.validation.studentForm.STUDENT_PHONE.$error,
                  "error-label": "Phone must be numeric"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Phone",
                    value: _vm.studentForm.STUDENT_PHONE,
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.studentForm.STUDENT_PHONE.$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.studentForm.STUDENT_PHONE
                          .$invalid
                      }
                    ],
                    required: ""
                  },
                  on: {
                    blur: _vm.validation.studentForm.STUDENT_PHONE.$touch,
                    keyup: function($event) {
                      $event.stopPropagation()
                      _vm.updateForm({
                        form: "studentForm",
                        field: "STUDENT_PHONE",
                        value: $event.target.value
                      })
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "q-pb-xl" }, [
      _c("h5", [_vm._v(" Location ")]),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-12" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Address 1",
                  value: _vm.addressForm.ADDRESS_1,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateForm({
                      form: "addressForm",
                      field: "ADDRESS_1",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-12" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Address 2",
                  value: _vm.addressForm.ADDRESS_2,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateForm({
                      form: "addressForm",
                      field: "ADDRESS_2",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "City",
                  value: _vm.addressForm.CITY,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateForm({
                      form: "addressForm",
                      field: "CITY",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-select", {
                attrs: {
                  "float-label": "State",
                  value: _vm.addressForm.LK_STATE_ID,
                  options: _vm.stateOptions
                },
                on: {
                  change: function(val) {
                    return _vm.updateForm({
                      form: "addressForm",
                      field: "LK_STATE_ID",
                      value: val
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Zip",
                  value: _vm.addressForm.ZIP_CODE,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateForm({
                      form: "addressForm",
                      field: "ZIP_CODE",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "q-pt-xl" },
        [
          _c("h5", [_vm._v(" Student Notes ")]),
          _c(
            "q-field",
            { staticClass: "q-pa-md" },
            [
              _c("q-input", {
                attrs: {
                  rows: "7",
                  type: "textarea",
                  "float-label": "Notes",
                  "max-height": 100,
                  value: _vm.studentForm.notes
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateStudentForm({
                      field: "notes",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }